var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHButtonBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 87,
    viewBox: "0 0 132 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4511 80.1423C58.3789 76.1025 51.3567 73.9671 44.974 75.1114C42.7698 75.5066 40.4997 75.7129 38.1811 75.7129C17.1671 75.7129 0.131836 58.7657 0.131836 37.8602C0.131836 16.9548 17.1671 0.00756836 38.1811 0.00756836C44.5544 0.00756836 50.5617 1.56644 55.8388 4.32181C65.3294 9.27724 86.2905 10.9872 96.8737 9.36713C98.3903 9.13496 99.944 9.01453 101.526 9.01453C118.284 9.01453 131.868 22.5291 131.868 39.2001C131.868 50.7816 125.312 60.8397 115.691 65.9016C112.52 67.5694 109.79 70.0514 107.825 73.0461C102.409 81.2976 93.0448 86.7508 82.4 86.7508C75.2314 86.7508 68.6434 84.2777 63.4511 80.1423Z",
    fill: "url(#paint0_linear_1130_715)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1130_715",
    x1: 66.0001,
    y1: 0.00756836,
    x2: 120.115,
    y2: 91.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHButtonBg);
export default __webpack_public_path__ + "static/media/HButtonBG.87b5c0dbb7bea273f88dcb03991b44b9.svg";
export { ForwardRef as ReactComponent };